import type { FieldValues, UseControllerProps } from 'react-hook-form';
import { useController } from 'react-hook-form';

import type { DaDataFmsUnit, DaDataSuggestion } from '@pulse-web-ui/dadata';
import { HelperText } from '@pulse-web-ui/helper-text';

import type { DaDataFmsUnitSuggestionsProps } from '@entities/index';
import { DaDataFmsUnitSuggestion } from '@entities/index';

import { addTestAttribute } from '@shared/utils';

type DaDataSuggestionValue = DaDataSuggestion<DaDataFmsUnit>;

type DaDataFmsUnitControllerProps<T extends FieldValues> =
  UseControllerProps<T> &
    DaDataFmsUnitSuggestionsProps & {
      label: string;
      testId?: string;
    };

export const DaDataFmsUnitController = <T extends FieldValues>({
  label,
  uid,
  disabled,
  onChange,
  unitCode,
  testId = 'dadataFmsUnit',
  ...controllerProps
}: DaDataFmsUnitControllerProps<T>) => {
  const { field, fieldState } = useController(controllerProps);

  const onDaDataFmsUnitChange = (data?: DaDataSuggestionValue) => {
    if (data) {
      field.onChange(data?.value);
      onChange?.(data);
    }
  };

  return (
    <HelperText
      status={!!fieldState.error ? 'error' : 'default'}
      message={fieldState.error?.message}
    >
      <DaDataFmsUnitSuggestion
        value={{ value: field.value || '' } as DaDataSuggestionValue}
        onChange={onDaDataFmsUnitChange}
        uid={uid}
        unitCode={unitCode}
        httpCache
        inputProps={{
          ...field,
          value: field.value,
          disabled,
          error: !!fieldState.error,
          label,
          autoComplete: 'nope',
          ...addTestAttribute(testId),
        }}
      />
    </HelperText>
  );
};
